import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonTextarea, ModalController, NavParams, PickerColumn, PickerController } from '@ionic/angular';
import mixpanel from 'mixpanel-browser';
import * as moment from 'moment';
import { AppState } from 'src/app/app.service';
import { I18n } from 'src/app/i18n.service';
import { Path } from 'src/app/path/path-v2.model';
import { ToasterService } from 'src/app/toaster.service';
import { User } from 'src/app/user/user.model';
@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class FeedbackFormComponent implements OnInit {
  // @Input() mainlist;
  // @Input() item;
  @Input() IsHomescreen;
  @Input() fromToDoListScreen;
  currentPath: Path;
  currentUser: User;
  currentDay: number
  routineList: any
  isCheckedAll: boolean = false
  routineLevels: any
  isExpanded: boolean = false
  routineId: number
  scheduledDay: number
  postMsg: any = "";
  currentRoutine: any
  isNextScreen: boolean = false
  makeHabit: boolean
  levelId: any
  levelNumber: number
  routineDay: number
  isMobile: boolean
  message: string =''
  mainItem: any;
  item: any;
  index: any;
  selectedDate: any = moment().format('MMMM DD, YYYY');;
  //private date: any = moment().toISOString();
  isKeyBoardOpen = false;
  feedbackFormLabel;
  @ViewChild('textarea', { static: false }) textarea: IonTextarea;
  @ViewChild('datePicker') datePicker;
  constructor(
    private modalController: ModalController,
    private cdRef: ChangeDetectorRef,
    private appState: AppState,
    private tostrService: ToasterService,
    private i18n: I18n,
    private navParams: NavParams,
    private pickerController: PickerController,
  ) {
    this.currentPath = this.appState.get("currentPath");
    this.currentUser = this.appState.get("currentUser");
    this.scheduledDay = this.appState.get("scheduleDayForCurrentStep")
    this.currentDay = this.appState.get('currentScheduleDay')
    this.levelNumber = this.appState.get('levelId')
    this.isMobile = this.appState.get('isMobile')
    this.appState.set('page', 1)
  }

  ngOnInit() {
    this.mainItem = this.navParams.get('mainItem');
    this.item = this.navParams.get('subItem');
    this.index = this.navParams.get('index');
    this.feedbackFormLabel = this.i18n.t("How did it go? What did you learn? (This reflection will be visible to your colleagues.)")
    this.keyBoardEvent();
    this.selectedDate = moment().format('MMMM DD, YYYY');
  }
  private capitalizeSentences(text: string): string {
    return text.replace(/(?:^|\.\s)([a-z])/g, (match) => match.toUpperCase());
  }
  capitalLine(event): void {
    const textareaElement = this.textarea?.getInputElement();
    let ele = document.getElementsByClassName("web-textarea");
    // const lineHeight = parseFloat(getComputedStyle(this.textarea['el']).lineHeight);
    if (event && event.target.value) {
      this.message = this.capitalizeSentences(event.target.value);
    }
  }
  onTextModification(ev) {
    console.log("called on change", ev.target.value);
    this.capitalLine(ev)
  }
  keyBoardEvent() {
    window.addEventListener('keyboardWillShow', (event: any) => {
      this.isKeyBoardOpen=true;
      console.log('is changed done')
      this.cdRef.detectChanges();
    });
    window.addEventListener('keyboardWillHide', (event: any) => {
      this.isKeyBoardOpen=false;
      console.log('is changed keyboardWillHide')
      this.cdRef.detectChanges();
    });
  }
  dateChanged(event) {
    const newDate = event.detail.value;
    if (newDate) {
      this.selectedDate = newDate;
      mixpanel.track('Date Change Value', { date: this.selectedDate });
    }
  }

  async openDatePicker() {
    const currentDate = moment(this.selectedDate, 'MMMM DD, YYYY');
    const picker = await this.pickerController.create({
      buttons: [
        {
          text: this.i18n.t('Cancel'),
          role: 'cancel'
        },
        {
          text: this.i18n.t('Confirm'),
          handler: (value) => {
            if (value && value.day && value.month && value.year) {
              const selectedDay = value.day.value;
              const selectedMonth = value.month.value;
              const selectedYear = value.year.value;
  
              this.selectedDate = `${this.getMonthName(
                parseInt(selectedMonth)
              )} ${selectedDay}, ${selectedYear}`;
              // mixpanel.track('Date Change Value', { date: this.selectedDate });
            }
          }
        }
      ],
      columns: this.generateDateOptions(currentDate.month() + 1, currentDate.date(), currentDate.year())
    });
    await picker.present();
  }

  generateDateOptions(selectedMonth: number, selectedDay: number, selectedYear: number) {
    const dateOptions = Array.from({ length: 31 }, (_, i) => {
      return {
        text: (i + 1).toString().padStart(2, '0'),
        value: (i + 1).toString().padStart(2, '0')
      };
    });
  
    const monthOptions = Array.from({ length: 12 }, (_, i) => {
      return {
        text: this.getMonthName(i + 1),
        value: (i + 1).toString().padStart(2, '0')
      };
    });
  
    const currentYear = new Date().getFullYear();
    const maxYearsAhead = 10; // You can modify this range as needed
    const yearOptions = Array.from({ length: maxYearsAhead + 1 }, (_, i) => {
      return {
        text: (currentYear + i).toString(),
        value: (currentYear + i).toString()
      };
    });
  
    const columns: PickerColumn[] = [
      { name: 'month', options: monthOptions, selectedIndex: selectedMonth - 1 },
      { name: 'day', options: dateOptions, selectedIndex: selectedDay - 1 },
      { name: 'year', options: yearOptions, selectedIndex: currentYear - selectedYear }
    ];
    return columns;
  }

  getMonthName(monthNumber) {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];  
        return monthNames[monthNumber - 1];
  }

  close() {
    this.modalController.dismiss();
  }

  getReps(item) {
    return item.repsData
  }
  logaRep(routine: any, level: any, index: any) {
    mixpanel.track('Commitment-log review', {reviewMessage: this.message})
    if (level.isHabitUnlocked === false) {
      this.tostrService.error(this.i18n.t('Please complete previous level.'))
    } else {
      localStorage.setItem('repLogText', this.message ? this.message : "");
      this.modalController.dismiss({
        routine: routine,
        level: level,
        index: index
      });
    }

  }

}
